import Input from '../common/Input';
import Button from '../common/Button';
import ConnectionStatusBadge from './ConnectionStatusBadge';
import SmtpErrorDetails from './SmtpErrorDetails';

/**
 * SMTP Settings Component
 * Form for configuring SMTP email server settings
 */
export default function SmtpSettings({ settings, onChange, onTestConnection, onTestEmail, connectionStatus, connectionError }) {
  const handleChange = (field, value) => {
    onChange({ ...settings, [field]: value });
  };

  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-medium text-gray-900">SMTP Configuration</h3>
        <p className="mt-1 text-sm text-gray-500">
          Configure email server settings for sending contract notifications
        </p>
        {connectionStatus && (
          <div className="mt-3">
            <ConnectionStatusBadge
              status={connectionStatus}
              error={connectionError}
              onShowDetails={(error) => <SmtpErrorDetails error={error} />}
            />
          </div>
        )}
      </div>

      {connectionError && (
        <SmtpErrorDetails error={connectionError} />
      )}

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Input
          label="SMTP Host"
          value={settings.host || ''}
          onChange={(e) => handleChange('host', e.target.value)}
          placeholder="smtp.gmail.com"
          required
        />

        <Input
          label="SMTP Port"
          type="number"
          value={settings.port || ''}
          onChange={(e) => handleChange('port', e.target.value)}
          placeholder="587"
          required
        />

        <Input
          label="SMTP Username"
          value={settings.user || ''}
          onChange={(e) => handleChange('user', e.target.value)}
          placeholder="noreply@example.com"
          required
        />

        <Input
          label="SMTP Password"
          type="password"
          value={settings.password || ''}
          onChange={(e) => handleChange('password', e.target.value)}
          placeholder="Enter password"
          required
        />

        <Input
          label="Sender Name"
          value={settings.from_name || ''}
          onChange={(e) => handleChange('from_name', e.target.value)}
          placeholder="Contract Management System"
        />

        <Input
          label="Sender Email"
          type="email"
          value={settings.from_email || ''}
          onChange={(e) => handleChange('from_email', e.target.value)}
          placeholder="noreply@example.com"
        />

        <div className="flex flex-col">
          <div className="flex items-center">
            <input
              type="checkbox"
              id="smtp-secure"
              checked={settings.secure === 'true'}
              onChange={(e) => handleChange('secure', e.target.checked ? 'true' : 'false')}
              className="h-4 w-4 text-primary-600 focus:ring-primary-500 border-gray-300 rounded"
            />
            <label htmlFor="smtp-secure" className="ml-2 block text-sm text-gray-900">
              Use SSL/TLS encryption
            </label>
          </div>
          <p className="mt-1 text-xs text-gray-500 ml-6">
            Enable for secure connection. Works with both port 465 (implicit SSL) and port 587 (explicit SSL/STARTTLS).
          </p>
        </div>
      </div>

      <div className="flex justify-end gap-3">
        <Button variant="secondary" onClick={onTestConnection}>
          Test Connection
        </Button>
        <Button variant="secondary" onClick={onTestEmail}>
          Send Test Email
        </Button>
      </div>
    </div>
  );
}